<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-tabs>
        <vs-tab label="ข้อมูลการโทร">
          <CallHistoryTab></CallHistoryTab>
        </vs-tab>
        <vs-tab label="ข้อมูลการส่ง SMS">
          <SendSmsHistoryTab></SendSmsHistoryTab>
        </vs-tab>
        <vs-tab label="ข้อมูลการส่งเอกสาร">
          <SendDocHistoryTab></SendDocHistoryTab>
        </vs-tab>
        <vs-tab label="ข้อมูลการส่ง Notification">
          <NotificationTab></NotificationTab>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import CallHistoryTab
  from "@/views/pages/Accounting/Contract/Detail/Components/DebtTrackingTab/Components/CallHistoryTab/index.vue";
import SendSmsHistoryTab
  from "@/views/pages/Accounting/Contract/Detail/Components/DebtTrackingTab/Components/SendSmsHistoryTab/index.vue";
import SendDocHistoryTab
  from "@/views/pages/Accounting/Contract/Detail/Components/DebtTrackingTab/Components/SendDocHistoryTab/index.vue";
import NotificationTab
  from "@/views/pages/Accounting/Contract/Detail/Components/DebtTrackingTab/Components/NotificationTab/index.vue";

export default {
  name: 'DebtTrackingTab',
  components: {
    CallHistoryTab,
    SendSmsHistoryTab,
    SendDocHistoryTab,
    NotificationTab,
  },
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}
</style>
